<template>
  <main id="selecionar-empresa" class="ohx login-modal">
    <v-content class="ohx">
      <v-container fluid grid-list-xs class="white-background ohx pb-4">
        <v-layout row wrap>
          <v-flex xs12>
            <form-alert
              :type="alertText.type"
              :message="alertText.message"
              @close="closeFormAlert"
            ></form-alert>
          </v-flex>
          <v-flex xs12 v-if="!showConfirmText">
            <h2 class="title">Atualizar Senha</h2>

            <v-layout row wrap>
              <v-flex xs7>
                <v-text-field
                  class="form-input-box mt-3 mb-0"
                  label="Senha Antiga"
                  type="password"
                  @input="$refs.confirmPassword.validate()"
                  v-model="model.oldPassword"
                  placeholder=" "
                ></v-text-field>
              </v-flex>

              <v-flex xs7>
                <v-text-field
                  class="form-input-box mt-4 password-input"
                  label="Nova senha"
                  v-model="model.password"
                  ref="confirmPassword"
                  @input="$forceUpdate()"
                  placeholder=" "
                  type="password"
                  loading
                >
                  <v-progress-linear
                    slot="progress"
                    :value="progress"
                    height="7"
                    :color="color"
                  ></v-progress-linear>
                </v-text-field>
                <small v-html="passwordStrength" :class="textColor"></small>
              </v-flex>
              <v-flex xs7>
                <v-text-field
                  class="form-input-box mt-3 mb-0 confirm-password"
                  label="Confirmar nova senha"
                  type="password"
                  :rules="[
                    (value) =>
                      value == this.model.password ||
                      'Senhas devem ser iguais!',
                    (value) =>
                      progress >= 50 || 'Força mínima da senha deve ser média!',
                  ]"
                  v-model="model.confirmPassword"
                  placeholder=" "
                ></v-text-field>
              </v-flex>
              <v-flex xs4 offset-xs8>
                <button
                  class="button jns-button yellow-button"
                  :disabled="
                    progress < 50 ||
                    model.password != model.confirmPassword ||
                    !model.oldPassword
                  "
                  @click="updatePassword()"
                >
                  Alterar
                </button>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 v-if="showConfirmText">
            <h2 class="title">Atualizar Senha</h2>
            <p class="description">Senha atualizada com sucesso!</p>
            <v-layout row wrap>
              <v-flex xs4 offset-xs8>
                <button
                  class="button jns-button yellow-button"
                  @click="close()"
                >
                  OK
                </button>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </main>
</template>

<style lang='scss' scoped>
#jns {
  .description {
    color: #888;
    font-size: 16px;
  }
  .title {
    font-weight: bold;
    margin-bottom: 10px;
    color: #4e4e4e;
  }
  .white-background {
  }
  .text--success {
    color: #4caf50;
  }
  .text--warning {
    color: #ffc107;
  }
  .text--error {
    color: #ff5252;
  }

  .text--primary {
    color: #c2c2c2;
  }
}
</style>

<script lang="js">
import ViewMixin from "@/mixins/ViewMixin";
export default {
  name: "AtualizarSenhaModal",
  mixins: [ViewMixin],
  data: () => ({
    alertText: false,
    showConfirmText: false,
    model: {},
    rules: {},
  }),

  computed: {
    filteredItems() {},

    progress() {
      if (!this.model.password) return 0;

      if (
        this.model.password.length > 7 &&
        this.model.password.match(
          /(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.*[\d])/
        )
      ) {
        return 100;
      }

      if (
        this.model.password.length > 7 &&
        this.model.password.match(/(?=.*[a-z])(?=.*[\d])/)
      ) {
        return 50;
      } else {
        return 20;
      }

      // return (this.model.password) ? Math.min(100, this.model.password.length * 10) : 0
    },
    color() {
      if (!this.progress) return "primary";
      return ["error", "warning", "success"][Math.floor(this.progress / 40)];
    },
    textColor() {
      if (!this.progress) return "text--primary";
      return ["text--error", "text--warning", "text--success"][
        Math.floor(this.progress / 40)
      ];
    },
    passwordStrength() {
      if (!this.progress) return "Força da senha";
      return ["Fraca", "Média", "Forte"][Math.floor(this.progress / 40)];
    },
  },
  methods: {
    async updatePassword() {
      let t = this;
      let response;
      let atualizarSenhaAdapter = (model) => {
        return {
          antiga_senha: model.oldPassword,
          nova_senha: model.password,
          confirmacao_senha: model.confirmPassword,
        };
      };

      let payload = atualizarSenhaAdapter(this.model);
      t.showLoadingIndicator();
      t.model.hash = t.hash;

      payload.userId = t.userId;
      try {
        response = await t.$store.dispatch("CHANGE_PASSWORD", payload);
        t.hideLoadingIndicator();
        t.showConfirmText = true;
        this.reset();
      } catch (e) {
        t.$store.commit("SET_ALERT_TEXT", {
          type: "error",
          message: "Senha não pôde ser trocada!",
        });
        t.alertText = t.handleAlertText();
        t.$store.commit("SET_LOADING_INDICATOR_FLAG", false);
        t.hideLoadingIndicator();
      }
    },
    reset() {
      this.model = {};
    },
    close() {
      let t = this;
      t.$emit("close");
      setTimeout(() => {
        t.showConfirmText = false;
      }, 1000);
    },
  },

  
  props: ["userId"],
};
</script>





// WEBPACK FOOTER //
// ./src/components/AtualizarSenhaModal.vue